import classNames from 'clsx';
import React from 'react';

import { Icon } from '@swf/sports/components';

import styles from './Subtitle.scss';

interface Props {
  isOpen?: boolean;
}

const Subtitle: React.FC<Props> = ({ children, isOpen = false }) => (
  <div
    className={classNames(styles.titleWrapper, {
      [styles.open]: isOpen
    })}
  >
    <Icon name="chevron-medium-down" className={styles.icon} />
    <div>{children}</div>
  </div>
);

export default Subtitle;
